import { DeviceManagementComponentServiceAbstraction } from "@bitwarden/angular/auth/device-management/device-management-component.service.abstraction";

export class WebDeviceManagementComponentService implements DeviceManagementComponentServiceAbstraction {
  showHeaderInformation(): boolean {
    return false;
  }
}
